import { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { getAuthentication } from "@api/authenticate"

import api from "@api"
import { useAppContext } from "@components/AppContext"
import { PROJECT_STATE_OPEN } from "@components/Domain/Constants"

const readProjectOperation = api.get("backstage/ReadPublicPublishedProject")

const NOT_FOUND_ERROR_TITLE = "Project Not Found"
const UNEXPECTED_ERROR_TITLE = "Unexpected Error"
const NOT_FOUND_ERROR_DESCRIPTION = `
  Soft commit form link is not valid or expired. If you think that's a mistake,
  please contact us to get a new one.
`


const usePublishedProject = (projectId, sponsorId) => {
  const navigate = useNavigate()
  const { request, setAuthentication } = useAppContext()

  const [ error, setError ] = useState()
  const [ project, setProject ] = useState()

  let isInProgress
  useEffect(() => {
    const isBackstage = false
    const investorAuthentication = getAuthentication(isBackstage)

    if (investorAuthentication) {
      navigate(`/investments/${projectId}`)
      setAuthentication(investorAuthentication)

      return
    }

    if (isInProgress) { return }
    isInProgress = true

    const parameters = { id: projectId, sponsorId }

    request(readProjectOperation.id, parameters, [ "DocumentNotFoundError" ])
      .then(({ data }) => {
        setProject(data)

        const { state } = data
        const isOpen = state === PROJECT_STATE_OPEN

        if (!isOpen) {
          setError({
            title: NOT_FOUND_ERROR_TITLE,
            message: NOT_FOUND_ERROR_DESCRIPTION,
          })
        }
      })
      .catch(exception => {
        const { isExpected } = exception

        if (!isExpected) {
          return setError({
            title: UNEXPECTED_ERROR_TITLE,
            message: exception.message
          })
        }

        setError({
          title: NOT_FOUND_ERROR_TITLE,
          message: NOT_FOUND_ERROR_DESCRIPTION,
        })
      })
  }, [ projectId ])

  return [ project, error ]
}

export default usePublishedProject
